import { Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottieAnimationComponent } from 'src/app/@shared/components/lottie-animation/lottie-animation.component';
import { SanitizeHtmlPipe } from 'src/app/@shared/pipes/sanitizeHtml.pipe';
import { CreditsOverviewComponent } from 'src/app/features/credits/components/credits-overview/credits-overview.component';
import { UserCreditsStateService } from 'src/app/features/credits/services/user-credits-state.service';
import { ButtonComponent } from 'src/app/@core/components/ui/button/button.component';

@Component({
  selector: 'app-generation-loader',
  standalone: true,
  imports: [CommonModule, LottieAnimationComponent, SanitizeHtmlPipe, CreditsOverviewComponent, ButtonComponent],
  templateUrl: './generation-loader.component.html',
})
export class GenerationLoaderComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() animationData: unknown = null;
  @Input() bottomImageSvg: string = '';
  @Input() feature: string = '';
  @Input() featureId: string = '';
  @Input() userRole: string = '';
  // Credit mode the host feature consumes; forwarded to the exhaustion card so
  // its ready/depleted state (and Resume) reflects the right credit bucket.
  @Input() mode: 'ask' | 'agent' = 'agent';
  @Input() actionLabel: string = '';
  @Input() animationWidth: string = '300px';
  @Input() animationHeight: string = '300px';

  @Output() resume = new EventEmitter<{ threadId?: string }>();
  @Output() action = new EventEmitter<void>();

  constructor(private userCreditsState: UserCreditsStateService) { }

  /** Reactively derived from the live credits signal — updates as soon as a
   *  CREDITS_UPDATED socket event refreshes it, even if that happens after
   *  this component has already mounted and is showing the plain loader. */
  hasExhaustion = computed(() =>
    (this.userCreditsState.credits()?.exhaustions ?? [])
      .filter((exhaustion) => exhaustion.feature === this.feature && exhaustion.featureId === this.featureId)
  );

  onResume(event: { threadId?: string }): void {
    this.resume.emit(event);
  }
}
